import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-chip-atom',
  templateUrl: './chip-atom.component.html',
})
export class ChipAtomComponent {
  @Input() id?: string;
  @Input() label!: string;
  @Input() value!: string;
  @Input() color: 'neutral' | 'success' | 'primary' | 'info' | 'highligh' = 'primary';

  @Output() removeChip = new EventEmitter<{
    id?: string;
    value: string;
  }>();
}
